import React,{useState,useEffect} from 'react';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import './css/dashboard_style.css';
import { FaBars,FaHome, FaCalendarAlt, FaCog, FaQuestionCircle } from "react-icons/fa"; // Hamburger icon
import { API_URL_BASE } from './config';

function Dashboard() {
	const [userName, setUserName] = useState("");
	const [userId, setUserId] = useState("");
	const [token, setToken] = useState("");
	const [role, setRole] = useState("");
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const navigate = useNavigate();	
	const location = useLocation();
	
	/*const handleMenuClick = (component) => {
		//navigate("/events");
	   setActiveComponent(component);
	   setSidebarOpen(false); // close sidebar on mobile after click
	};*/
	
	const menuItems = [
	  { key: 'home', icon: <FaHome />, label: 'Home', path: '/dashboard' },
	  { key: 'events',  icon: <FaCalendarAlt />, label: 'Events', path: '/dashboard/events' },
	  { key: 'settings', icon: <FaCog /> , label: 'Company Settings' , path: '/dashboard/settings'},
	  { key: 'help', icon: <FaQuestionCircle />, label: 'Help Centre' , path: '/dashboard/help' }
	];
	
	const adminMenuItems = [
	  { key: 'admin', icon: <FaCog />, label: 'Admin', path: '/dashboard/admin' },
	];
	
	useEffect(() => {
		  const storedName = localStorage.getItem("userName");
		  const storedUserId = localStorage.getItem("userId");
		  const storedToken = localStorage.getItem("token");
		  const storedRole = localStorage.getItem("role");
		  
		  if (!storedName || !storedUserId) {
		    setUserName("User"); 
			setUserId("");
			setToken("");
			setRole("");
		  } else {
		    setUserName(storedName);
			setUserId(storedUserId);
			setToken(storedToken);
			setRole(storedRole);
		  }
	  }, [userName,userId,token, Dashboard]); 
	
	  	return (
	  		<div className="dashboard-wrapper">
	  			<div className="container">
	  				<div className="hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>
	  					<FaBars color="white" />
						<p>Buydeal.eu</p>
	  				</div>
	  				<div className={`dashboard ${sidebarOpen ? "sidebar-open" : ""}`}>
	  					<aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
	  						<div className="logo">Buydeal</div>
	  						<div className="welcome">Welcome   <b>{userName}!!</b></div>
	  						<div className="welcome">Userid: {userId}</div>
	  						<nav>
	  							<ul>
								{menuItems.map(item => (
								  <li
								    key={item.key}
								    className={location.pathname === item.path ? 'active disabled' : ''}>
									<Link to={item.path} onClick={() => setSidebarOpen(false)}>{item.icon} {item.label}</Link>								  
								  </li>
								  ))}
								  {role === "ADMIN" && adminMenuItems.map(item => (
								    <li
								      key={item.key}
								      className={location.pathname === item.path ? 'active disabled' : ''}>
								  	<Link to={item.path} onClick={() => setSidebarOpen(false)}>{item.icon} {item.label}</Link>
								    </li>
								  ))}
	  								<li>
	  									<button className="btn" onClick={() => {
	  										localStorage.clear();
	  										setUserName("");
	  										setUserId("");
	  										navigate("/");
											fetch(API_URL_BASE + `/ticket.json`,{
												method: 'POST',
												     headers: {
												       'Content-Type': 'application/json',
												     },
												     body: JSON.stringify({
												       logout: {
												           token: token
												       }
												     }),
												   });
											setToken("");		   
												   
	  									}}>Log Out</button>
	  								</li>
	  							</ul>
	  						</nav>
	  					</aside>

	  					<main className="content">
							<Outlet /> {/* This is where child routes render */}
	  					</main>
	  				</div>
	  			</div>
	  		</div>
	  	);
	  }

	  export default Dashboard;